// extracted by mini-css-extract-plugin
module.exports = {"divider":"_3vrvW"};